module.exports = __webpack_public_path__ + "static/tarjeta-regalo-83d41374f7df878d23ebcdee66fb24b2.jpg";